import { Button, DashboardModule, Text } from '@domain-group/suit-theme'

import InactiveImageUrl from './assets/inactive.svg'

const Domain = () => (
  <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Domain Group">
    <DashboardModule.BlankState
      imageBoxProps={{ justifyContent: ['center', 'flex-end'] }}
      imageUrl={InactiveImageUrl}
    >
      <DashboardModule.BlankState.Title>Domain Integration</DashboardModule.BlankState.Title>

      <DashboardModule.BlankState.Paragraph>
        Agencies can connect their Domain account to Realhub for items like product pricing,
        suburb information and listing views.
      </DashboardModule.BlankState.Paragraph>

      <DashboardModule.BlankState.Paragraph>
        This connection must be managed at the agency level.
        An Office Admin can connect their account from their Agency Admin Integrations page.
      </DashboardModule.BlankState.Paragraph>
    </DashboardModule.BlankState>

    <DashboardModule.Footer boxProps={{ flexDirection: ['column', 'row'] }}>
      <Text color="faintGrey" fontSize="xsmall" marginBottom={['large', 0]}>
        Click Connect to Domain and enter your credentials
      </Text>

      <DashboardModule.FooterRight>
        <Button
          buttonStyle="secondaryEdit"
          disabled
          size="medium"
        >
          Connect to Domain
        </Button>
      </DashboardModule.FooterRight>
    </DashboardModule.Footer>
  </DashboardModule>
)

export default Domain
